module.exports = __webpack_public_path__ + "static/media/matte.3997e46f.pdf";